import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as Api from '../api';
import * as Types from '../types';
import { useAuthContext } from '../context';

/** Step 1: send an OTP to the phone, returns a challenge reference. */
export const useStartPhoneRegister = () =>
  useMutation({
    mutationFn: async (values: Types.IApi.StartPhoneRegister.Request) => {
      const { data } = await Api.StartPhoneRegister(values);
      return data;
    },
  });

/** Resend the signup OTP for an active challenge. */
export const useResendPhoneRegister = () =>
  useMutation({
    mutationFn: async (values: Types.IApi.PhoneChallenge.Request) => {
      const { data } = await Api.ResendPhoneRegister(values);
      return data;
    },
  });

/** Verify step: re-checks the OTP server-side and marks the challenge verified. */
export const useVerifyPhoneRegister = () =>
  useMutation({
    mutationFn: async (values: Types.IApi.VerifyPhoneRegister.Request) => {
      const { data } = await Api.VerifyPhoneRegister(values);
      return data;
    },
  });

/** Step 2: verify OTP, set password, create the account → signs the user in. */
export const useCompletePhoneRegister = () => {
  const queryClient = useQueryClient();
  const {
    methods: { setTokens },
  } = useAuthContext();

  return useMutation({
    mutationFn: async (values: Types.IApi.CompletePhoneRegister.Request) => {
      const { data } = await Api.CompletePhoneRegister(values);
      return data;
    },
    onSuccess: (data) => {
      queryClient.removeQueries({ queryKey: ['auth', 'profile'] });
      setTokens({ accessToken: data.accessToken, refreshToken: data.refreshToken });
    },
  });
};
